import {
	Button,
	Checkbox,
	FormControlLabel,
	MuiThemeProvider,
	TextField,
	createMuiTheme,
	Select,
	FormHelperText,
	MenuItem,
	FormControl,
	InputLabel,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls';
import { deleteUser, getUserById, postUser, updateUser } from '../../../../api/user';
import { getRegions } from '../../../../api/region';
import { alertError, alertSuccess } from '../../../../utils/logger';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { useSkeleton } from '../../../hooks/useSkeleton';

// Create theme for delete button (red)
const theme = createMuiTheme({ palette: { secondary: { main: '#F64E60' } } });

const MenuProps = {
	PaperProps: { style: { maxHeight: 48 * 4.5 + 8, width: 250 } },
	getContentAnchorEl: () => null,
};

function getEmptyEnterprise() {
	return {
		fullName: '',
		email: '',
		role: 'enterprise',
		password: '',
		repeatPassword: '',
		active: true,
		validation_required: true,
		region: null,
	};
}

const getDataSelect = (elements) =>
	elements.map(({ _id, name }) => ({ value: _id, label: name }));

export function EditEnterprisePage() {
	const [enterprise, setEnterprise] = useState(getEmptyEnterprise());
	const [regions, setRegions] = useState([]);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [newPassword, setNewPassword] = useState({
		password: null,
		repeatPassword: null,
	});
	const [changePassword, setChangePassword] = useState(false);
	const enterpriseId = useParams().id;
	const history = useHistory();

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	async function fetchRegions() {
		getRegions()
			.then((res) => {
				if (res.status === 200) setRegions(getDataSelect(res.data));
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: 'No se han podido obtener las regiones.',
				});
				history.push('/enterprises');
			});
	}

	useEffect(() => {
		if (!enterpriseId) {
			disableLoadingData();
			fetchRegions();
			return;
		}
		getUserById(enterpriseId)
			.then((res) => {
				if (res.status === 200) {
					const user = res.data;
					delete user.password;
					setEnterprise(user);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: 'No se ha podido obtener la empresa.',
				});
				history.push('/enterprises');
			});
		fetchRegions();
	}, [enterpriseId, disableLoadingData, history]);

	function saveEnterprise() {
		let saveEnterprise = enterprise;
		delete saveEnterprise.password;

		if (changePassword) {
			if (!newPassword.password || !newPassword.repeatPassword) {
				alertError({
					error: null,
					customMessage: 'Introduce una contraseña.',
				});
				return;
			}
			if (newPassword.password !== newPassword.repeatPassword) {
				alertError({
					error: null,
					customMessage: 'Las contraseñas no coinciden.',
				});
				return;
			}
			saveEnterprise = { ...saveEnterprise, password: newPassword.password };
		}
		if (!enterpriseId)
			postUser(saveEnterprise)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: '¡Creada!',
							customMessage: 'Empresa creada con éxito.',
						});
						history.push('/enterprises');
					}
				})
				.catch((error) =>
					alertError({
						error: error,
						customMessage: 'No se ha podido crear la empresa.',
					})
				);
		else
			updateUser(enterpriseId, saveEnterprise)
				.then((res) => {
					if (res.status === 200) {
						alertSuccess({
							title: '¡Guardada!',
							customMessage: 'Cambios guardados con éxito.',
						});
						history.push('/enterprises');
					}
				})
				.catch((error) =>
					alertError({
						error: error,
						customMessage: 'No se han podido guardar los cambios.',
					})
				);
	}

	const handleChange = (element) => (event) =>
		setEnterprise({ ...enterprise, [element]: event.target.value });

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title='Editar empresa' />
					<CardBody>
						<TextField
							id={`fullName`}
							label='Nombre'
							value={enterprise.fullName}
							onChange={handleChange('fullName')}
							InputLabelProps={{ shrink: true }}
							margin='normal'
							variant='outlined'
							required
						/>
						<TextField
							id={`email`}
							label='Email'
							value={enterprise.email}
							onChange={handleChange('email')}
							InputLabelProps={{ shrink: true }}
							margin='normal'
							variant='outlined'
							required
						/>
						{changePassword ? (
							<>
								<br />
								<br />
								<TextField
									id={`password`}
									label='Contraseña'
									value={newPassword.password}
									onChange={(event) => {
										if (event.target.value !== ' ')
											setNewPassword({
												...newPassword,
												password: event.target.value,
											});
									}}
									InputLabelProps={{ shrink: true }}
									type='password'
									margin='normal'
									variant='outlined'
									required
								/>
								<TextField
									id={`repeatPassword`}
									label='Confirmar contraseña'
									value={newPassword.repeatPassword}
									onChange={(event) => {
										if (event.target.value !== ' ')
											setNewPassword({
												...newPassword,
												repeatPassword: event.target.value,
											});
									}}
									InputLabelProps={{ shrink: true }}
									type='password'
									margin='normal'
									variant='outlined'
									required
								/>
								<br />
								<br />
								{enterpriseId && (
									<>
										<Button
											onClick={() => {
												setChangePassword(false);
												setNewPassword({
													password: null,
													repeatPassword: null,
												});
											}}
											variant='outlined'
											style={{ marginRight: '20px' }}>
											Cancelar cambio de contraseña
										</Button>
										<br />
										<br />
									</>
								)}
							</>
						) : enterpriseId ? (
							<>
								<br />
								<br />
								<Button
									onClick={() => setChangePassword(true)}
									variant='outlined'
									color='primary'
									style={{ marginRight: '20px' }}>
									Cambiar contraseña
								</Button>
								<br />
								<br />
							</>
						) : (
							<></>
						)}
						<br />
						<br />
						<FormControl style={{ width: '100%' }} className='mb-2'>
							<InputLabel id='demo-simple-select-standard-label'>
								{'Región *'}
							</InputLabel>
							<Select
								labelId='demo-simple-select-standard-label'
								id='demo-simple-select-standard'
								value={enterprise.region || ''}
								onChange={handleChange('region')}
								MenuProps={MenuProps}>
								{regions?.map(({ value, label }) => (
									<MenuItem key={value} value={value}>
										{label}
									</MenuItem>
								))}
							</Select>
							<FormHelperText>
								{
									'La región del usuario determina los contenidos que este tiene asignados.'
								}
							</FormHelperText>
						</FormControl>
						<br />
						<br />
						<FormControlLabel
							control={
								<Checkbox
									checked={enterprise.active}
									onChange={() =>
										setEnterprise({
											...enterprise,
											active: !enterprise.active,
										})
									}
									name='checkActive'
								/>
							}
							label='Activa'
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={!enterprise.validation_required}
									onChange={() =>
										setEnterprise({
											...enterprise,
											validation_required: !enterprise.validation_required,
										})
									}
									name='checkActive'
								/>
							}
							label='Cuenta de empresa validada'
						/>
					</CardBody>
				</Card>
				<Button
					onClick={() => history.push('/enterprises')}
					variant='outlined'
					style={{ marginRight: '20px' }}>
					Atrás
				</Button>
				<Button
					onClick={() => saveEnterprise()}
					variant='outlined'
					color='primary'
					style={{ marginRight: '20px' }}>
					Guardar empresa
				</Button>
				{enterpriseId && (
					<>
						<MuiThemeProvider theme={theme}>
							<Button
								onClick={() => setOpenConfirmDialog(true)}
								variant='outlined'
								color='secondary'>
								Eliminar empresa
							</Button>
						</MuiThemeProvider>

						<ConfirmDialog
							title={
								'¿Estás seguro de que quieres eliminar esta empresa?'
							}
							open={openConfirmDialog}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								deleteUser(enterpriseId)
									.then((res) => {
										if (
											res.status === 204 ||
											res.status === 200
										) {
											alertSuccess({
												title: '¡Eliminada!',
												customMessage:
													'Empresa eliminada con éxito.',
											});
											history.push('/enterprises');
										}
									})
									.catch((error) =>
										alertError({
											error: error,
											customMessage:
												'No se ha podido eliminar la empresa.',
										})
									);
							}}
						/>
					</>
				)}
			</>
		);
}
